if (document.getElementsByClassName('accordion-list').length > 0) {

const accordionList = document.querySelector(".accordion-list");

// Accordeon Function
let groups = gsap.utils.toArray(".accordion-group");
let menus = gsap.utils.toArray(".accordion-menu");
let menuToggles = groups.map(createAnimation);

menus.forEach((menu) => {
 menu.addEventListener("click", () => toggleMenu(menu));
});

function toggleMenu(clickedMenu) {
 menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
}

function createAnimation(element) {
 let menu = element.querySelector(".accordion-menu");
 let box = element.querySelector(".accordion-content .accordion-item__contenttext__inner");
 let plusElement = element.querySelector(".button-circle");
 let buttonCirclePath = element.querySelector(".button-circle .button-circle-path");

 gsap.set(box, { height: "auto" });

 let animation = gsap
  .timeline({
  onComplete: () => {
    plusElement.classList.add("is-active");
    element.classList.add("is-open");

    // accordion-list bekommt active klasse
    accordionList.classList.add("has-open");
  },
  onReverseComplete: () => {
    plusElement.classList.remove("is-active");
    element.classList.remove("is-open");

    // nur entfernen, wenn wirklich nichts mehr offen ist
    const openItems = accordionList.querySelectorAll(".accordion-group.is-open");
    if (openItems.length === 0) {
      accordionList.classList.remove("has-open");
    }
  }
})
  .from(box, {
    height: 0,
    duration: 0.5,
    ease: "power1.inOut"
  })
  .from(buttonCirclePath, { duration: 0.3, attr: { stroke:"#0f0e0e" }, ease:"none" }, 0)
  .to(buttonCirclePath, { duration: 0.3, attr: { stroke:"#0f0e0e" }, ease:"none" }, 0)
  .from(plusElement, { duration: 0.3, backgroundColor: '#00b7a6', rotation: 0, ease:"none" }, 0)
  .to(plusElement, { duration: 0.3, backgroundColor: '#00b7a6', rotation: 180, ease:"none" }, 0)
  .reverse();

 return function (clickedMenu) {
   if (clickedMenu === menu) {
     animation.reversed(!animation.reversed());
   } else {
     animation.reverse();
   }
 };
}



// Select the target node
const targetNode = document.querySelector('.accordion-list');


// Create a new MutationObserver instance
const observer = new MutationObserver((mutationsList, observer) => {
  for (let mutation of mutationsList) {
    if (mutation.type === 'childList') {

              // Accordeon Function
        let groups = gsap.utils.toArray(".accordion-group");
        let menus = gsap.utils.toArray(".accordion-menu");
        let menuToggles = groups.map(createAnimation);

        menus.forEach((menu) => {
        menu.addEventListener("click", () => toggleMenu(menu));
        });

        function toggleMenu(clickedMenu) {
        menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
        }

        function createAnimation(element) {
        let menu = element.querySelector(".accordion-menu");
        let box = element.querySelector(".accordion-content .accordion-item__contenttext__inner");
        let plusElement = element.querySelector(".button-circle");
        let buttonCirclePath = element.querySelector(".button-circle .button-circle-path");

        gsap.set(box, { height: "auto" });

        let animation = gsap
     .timeline({
  onComplete: () => {
    plusElement.classList.add("is-active");
    element.classList.add("is-open");

    // accordion-list bekommt active klasse
    accordionList.classList.add("has-open");
  },
  onReverseComplete: () => {
    plusElement.classList.remove("is-active");
    element.classList.remove("is-open");

    // nur entfernen, wenn wirklich nichts mehr offen ist
    const openItems = accordionList.querySelectorAll(".accordion-group.is-open");
    if (openItems.length === 0) {
      accordionList.classList.remove("has-open");
    }
  }
})
        .from(box, {
          height: 0,
          duration: 0.5,
          ease: "power1.inOut"
        })
        .from(buttonCirclePath, { duration: 0.3, attr: { stroke:"#0f0e0e" }, ease:"none" }, 0)
        .to(buttonCirclePath, { duration: 0.3, attr: { stroke:"#0f0e0e" }, ease:"none" }, 0)
        .from(plusElement, { duration: 0.3, backgroundColor: '#00b7a6', rotation: 0, ease:"none" }, 0)
        .to(plusElement, { duration: 0.3, backgroundColor: '#00b7a6', rotation: 180, ease:"none" }, 0)
        .reverse();

        return function (clickedMenu) {
          if (clickedMenu === menu) {
            animation.reversed(!animation.reversed());
          } else {
            animation.reverse();
          }
        };
        }


    } else if (mutation.type === 'attributes') {

    }
  }
});

// Set observer configuration
const config = {
  childList: true, // Listen for child node additions/removals
  attributes: true, // Listen for attribute changes
  subtree: true, // Observe the entire subtree
};

// Start observing the target node
observer.observe(targetNode, config);

}
